<template>
	<dialog-slot
			:title="title"
			@updateClose="onCloseDialog"
			@updateSave="onSave"
			:is-btn-safe="$v.$invalid"
			width="450px"
	>

		<div class="rowWrap">
			<field
					:classError="$v.date.$error"
					margin="0"
					type="text"
					label="Action date"
					placeholder="Enter date"
					:dateValue="date"
					@updateDate="onDate($event)"
					is-date
					is-no-title
					is-required
			></field>

			<field
					:classError="$v.time.$error"
					margin="0"
					label="Action time"
					placeholder="HH:MM"
					:setInputValue="time"
					@updateInput="onInput($event, 'time')"
					is-required
					is-input
					is-time-field
			/>
		</div>

		<radio-field
				v-model="status_id"
				:items="issueList"
				label="Issue type"
				:validation="$v.status_id"
				error-text="Please select issue type"
		></radio-field>

		<field
				:classError="$v.notes.$error"
				margin="0 0 10px"
				min-height="100px"
				width="480"
				label="Description"
				placeholder="Enter description"
				:setInputValue="notes"
				@updateInput="onInput($event, 'notes')"
				is-auto-grow
				is-textarea
				is-required
		></field>

		<!--			:classError="$v.file.value.$error"-->
		<paste-image-field
				v-model="screenshot"
				:required="false"
				:max-size="5 * 1024 * 1024"
				:accept="['image/png','image/jpeg','image/webp']"
				@meta="onUpdatePasteImageField"
				:screenshotEdit="screenshotEdit"
		/>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

import getDefaultDate from "@/helper/getDefaultDate";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import getChicagoTime from "@/helper/getChicagoTime";
import getChicagoDate from "@/helper/getChicagoDate";
import RadioField from "@/shared/RadioField/RadioField.vue";
import PasteImageField from "@/components/PasteImageField/PasteImageField.vue";
export default {
	name: "AddException",
	mixins: [ validationMixin ],
	components: { PasteImageField, RadioField, DialogSlot },

	props: {
		title: String
	},
	data: () => ({
		date: "",
		time: "",
		notes: "",
		status_id: null,
		issueList: [
			{ id: 1, name: 'Miss in CRM' },
			{ id: 2, name: 'Need to transfer' },
			{ id: 3, name: 'Other' }
		],

		file: {
			name: "",
			value: ""
		},
		screenshot: null,
		screenshotEdit: null,
	}),
	validations() {
		return {
			date: { required },
			time: { required },
			notes: { required },
			status_id: { required },
			// file: {
			// 	value: { required }
			// }
		};
	},
	methods: {
		onUpdatePasteImageField(el) {
			const { dataUrl, name } = el;
			this.file.name = name;
			this.file.value = dataUrl;
		},
		onCloseDialog() {
			this.$emit("updateCloseDialog");
		},

		onInput({ value }, key) {
			this[key] = value;
		},

		onDate(value) {
			this.date = value;
			if (this.$v && this.$v.date) {
				this.$v.date.$touch();
			}
		},

		onSave() {
			this.$v.$touch();
			if (this.$v.$invalid) return;

			this.$emit("updateExceptionSave", {
				description: this.notes,
				date: this.date,
				time: this.time || getDefaultDate(1, null, true),
				status_id: this.status_id,
				file: this.file.value,
				file_name: this.file.name
			});
		}
	},
	mounted() {
		this.date = getChicagoDate();
		this.time = getChicagoTime();

		console.log("Chicago date Old false: getDefaultDate", getDefaultDate());
		console.log("Chicago date: NEW True: getChicagoDate", getChicagoDate());
		console.log("Local date:", new Date().toLocaleDateString());
	}
};
</script>

<style scoped lang="scss">
.rowWrap {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-bottom: 10px;
}
</style>

